<template>
    <div>
        <fullscreen-drawer
            v-if="featureFlags['live-site-responsive-design']"
            :visible="visible"
            :wrap-style="wrapStyle"
            height="100%"
            get-container="#app"
            placement="bottom"
            class="TrolleyOnboardingStepsDrawer"
            :closable="false"
            @close="handleClose"
        >
            <OnboardingStep
                :is-trolley="true"
                title="You’re almost finished!"
                message="Get set up to receive payouts."
                :current-step-id="-1"
                :image="ONBOARDING_STEPS_TROLLEY_IMAGE"
                @close="handleClose"
                @continue="handleClose"
            />
        </fullscreen-drawer>

        <g-drawer
            v-else
            :visible="visible"
            :wrap-style="wrapStyle"
            height="100%"
            get-container="#app"
            placement="bottom"
            class="TrolleyOnboardingStepsDrawer"
            :closable="false"
            @close="handleClose"
        >
            <OnboardingStep
                :is-trolley="true"
                title="You’re almost finished!"
                message="Get set up to receive payouts."
                :current-step-id="-1"
                :image="ONBOARDING_STEPS_TROLLEY_IMAGE"
                @close="handleClose"
                @continue="handleClose"
            />
        </g-drawer>
    </div>
</template>

<script>
    import { reactive } from 'vue-demi';
    import OnboardingStep from './OnboardingStep.vue';
    import { ONBOARDING_STEPS_TROLLEY_IMAGE } from '../../../../../app-v2/constants/payouts';
    import FullscreenDrawer from '../../../../../app-v2/components/library/FullscreenDrawer.vue';
    import { useFeatureFlagsStore } from '../../../../../stores';

    export default {
        components: {
            FullscreenDrawer,
            OnboardingStep
        },

        name: 'TrolleyOnboardingStepsDrawer',

        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },

        setup(props, context) {
            const featureFlags = useFeatureFlagsStore().data;

            const wrapStyle = reactive({
                position: 'absolute'
            });

            const handleClose = () => {
                context.emit('close');
            };

            return {
                handleClose,
                wrapStyle,
                ONBOARDING_STEPS_TROLLEY_IMAGE,
                featureFlags
            };
        }
    };
</script>

<style lang="scss" scoped>
    ::v-deep .ant-steps-item-title {
        color: $g-color-grey-8 !important;
    }
</style>
